import Link from 'next/link';
import React from 'react';
import { useBlocksStore } from '../../hooks/useBlocksStore';
import defaultBlocksInCity from '../../utils/defaultBlocksInCity';
import formatNumber from '../../utils/formatNumber';
import InToViewWrapper from '../InToViewWrapper';
import CityImage from './CityImage';

const CityPreview = ({ city, onClick }) => {
  const classes = 'bg-gray-900 group transition duration-300 block w-full rounded-lg overflow-hidden';

  if (typeof onClick === 'function') {
    return (
      <InToViewWrapper>
        <button type='button' className={classes} onClick={onClick}>
          <CityPreviewInner city={city} />
        </button>
      </InToViewWrapper>
    );
  }

  return (
    <InToViewWrapper>
      <Link href={`/cities/${city.index}`}>
        <a className={classes}>
          <CityPreviewInner city={city} />
        </a>
      </Link>
    </InToViewWrapper>
  );
};

const CityPreviewInner = ({ city }) => {
  const { allBlocks } = useBlocksStore();
  const meta = city.metadata?.properties;

  const blocksForImage = [...defaultBlocksInCity].map((block) => {
    if (!meta?.[`Block #${block.index}`]) return block;
    const id = meta?.[`Block #${block.index}`].split(' - ')[1];
    if (!id) return block;
    const blockData = allBlocks.find((block) => block.index === parseInt(id));
    return { ...block, block: blockData };
  });
  const numberOfFilledBlocks = blocksForImage.filter((block) => block.block).length;
  const cityName = city?.details?.name || city?.params?.name;

  return (
    <>
      <CityImage imageUrl={city.image} />

      <div className='flex-1 p-6 text-left flex flex-col gap-3 xl:gap-0 xl:flex-row justify-between group-hover:bg-gray-700 transition duration-150'>
        <div className='max-w-[300px]'>
          <p className='text-gray-500 text-sm'>{city?.details?.name ? <>{city?.params?.name}</> : <>&nbsp;</>}</p>
          <p className='font-medium text-lg leading-tight'>{cityName}</p>
          <p className='text-gray-500 mt-1'>{city.index}</p>
        </div>

        <div className='flex gap-4 items-center'>
          <p className='text-gray-500 flex flex-col items-center justify-center gap-1'>
            <span>Blocks</span>
            <span className='text-xl font-bold text-white'>{numberOfFilledBlocks}</span>
          </p>
          <p className='text-gray-500 flex flex-col items-center justify-center gap-1'>
            <span>Population</span>
            <span className='text-xl font-bold text-white'>
              {city.currentPopulation}/{city.maxPopulation}
            </span>
          </p>
          <p className='text-gray-500 flex flex-col items-center justify-center gap-1'>
            <span>Rarity Score</span>
            <span className='text-xl font-bold text-white'>{formatNumber(city.rarityScore)}</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default CityPreview;
